<template>
    <section>
        <code>{{ code }} </code>
        <h3>{{ message }} </h3>
        <a href="javascript:history.back();">
            Back
        </a>
    </section>
</template>

<script>
    export default {
        name: "Error",
        props: ['code', 'message'],
        created() {
            if (!this.code || !this.message) {
                this.$router.replace({name: 'index'});
            }
            
            document.title = 'Error ' + this.code + ' - ' + process.env.APP_NAME;
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/Error.vue